(()=>{
    const relics=[
      {name:'ASTEROID',apiName:'ASTEROID',kicker:'AGNI',image:'//varanasimovie.com/cdn/shop/t/3/assets/asteroid.png?v=29451966105964851441786359647',position:'50% 62%',accent:'#ff943d'},
      {name:'RUDHRA',apiName:'RUDRA',kicker:'THE WARRIOR',image:'//varanasimovie.com/cdn/shop/t/3/assets/rudra.png?v=184079360327552436791786359647',position:'50% 30%',accent:'#d9a264'},
      {name:'TRISHUL',apiName:'TRISHUL',kicker:'THE WEAPON',image:'//varanasimovie.com/cdn/shop/t/3/assets/trishul.png?v=46544242224381019341786359647',position:'51% 50%',accent:'#f0ba67'},
      {name:'RANA KUMBHA',apiName:'KUMBHA',kicker:'THE FORCE',image:'//varanasimovie.com/cdn/shop/t/3/assets/kumbha.png?v=79974384293222491981786359647',position:'50% 28%',accent:'#a8b0af'},
      {name:'MANDAKINI',apiName:'MANDAKINI',kicker:'THE FIRE',image:'//varanasimovie.com/cdn/shop/t/3/assets/mandakini.png?v=76841027196146126221786359647',position:'58% 40%',accent:'#f6a332'},
      {name:'RAMA',apiName:'RAM_BAANAM',kicker:'THE ARROW',image:'//varanasimovie.com/cdn/shop/t/3/assets/ram-baanam.png?v=68473329436036611931786359647',position:'50% 50%',accent:'#60d9ff'}
    ];
    const RUDHRA_INDEX=relics.findIndex(relic=>relic.apiName==='RUDRA');
    const $=id=>document.getElementById(id);
    const SVG_NS='http://www.w3.org/2000/svg';
    const COIN_FRONT_URL='//varanasimovie.com/cdn/shop/t/3/assets/varanasi-perk-coin-front.png?v=149032283516290657191786359647';
    const COIN_BACK_URL='//varanasimovie.com/cdn/shop/t/3/assets/varanasi-perk-coin-back.png?v=1296418673239530481786359647';

    const safeResourceUrl=(raw)=>{
      const value=String(raw||'').trim();
      if(!value)throw new TypeError('Empty resource URL.');
      const parsed=new URL(value,window.location.origin);
      if(parsed.protocol!=='https:' && parsed.protocol!=='http:'){
        throw new TypeError('Blocked unsafe resource URL protocol.');
      }
      return parsed.href;
    };

    const appendSvgElement=(parent,tag,attrs={})=>{
      const node=document.createElementNS(SVG_NS,tag);
      Object.entries(attrs).forEach(([name,value])=>node.setAttribute(name,String(value)));
      parent.appendChild(node);
      return node;
    };

    const createGlobe=()=>{
      const svg=appendSvgElement(document.createDocumentFragment(),'svg',{
        class:'globeMark',viewBox:'0 0 80 80','aria-hidden':'true',focusable:'false'
      });
      appendSvgElement(svg,'circle',{cx:40,cy:40,r:27});
      appendSvgElement(svg,'ellipse',{cx:40,cy:40,rx:12,ry:27});
      appendSvgElement(svg,'path',{d:'M14 40h52M18 28c14 7 30 7 44 0M18 52c14-7 30-7 44 0'});
      appendSvgElement(svg,'path',{class:'globeMeteor',d:'M62 18 72 8M67 18l5-10-10 5'});
      return svg;
    };

    const createCoin=(compact=false)=>{
      const root=document.createElement('div');
      root.className='goldCoin'+(compact?' goldCoin--compact':'');
      root.setAttribute('aria-label','Rotating Varanasi Perk Coin');

      const halo=document.createElement('span');
      halo.className='coinHalo';
      root.appendChild(halo);

      const spinner=document.createElement('div');
      spinner.className='coinSpinner';

      [
        ['coinSide coinSide--front',COIN_FRONT_URL,'Varanasi side of Gold Coin'],
        ['coinSide coinSide--back',COIN_BACK_URL,'Trishul side of Gold Coin']
      ].forEach(([className,url,alt])=>{
        const side=document.createElement('div');
        side.className=className;
        const img=document.createElement('img');
        img.src=safeResourceUrl(url);
        img.alt=alt;
        side.appendChild(img);
        spinner.appendChild(side);
      });

      root.appendChild(spinner);
      return root;
    };

    document.querySelectorAll('.globeHere').forEach((node)=>node.replaceChildren(createGlobe()));
    document.querySelectorAll('.coinHere').forEach((node)=>node.replaceChildren(createCoin(false)));

    const relicChips=$('relicChips');
    relicChips.replaceChildren(...relics.map((relic,index)=>{
      const chip=document.createElement('div');
      chip.className='relicChip';
      const number=document.createElement('span');
      number.textContent='0'+String(index+1);
      const label=document.createElement('b');
      label.textContent=relic.name;
      chip.append(number,label);
      return chip;
    }));
    let transferredPlayer=null;
    try{
      transferredPlayer=JSON.parse(sessionStorage.getItem('varanasiPlayer')||'null');
    }catch(e){
      transferredPlayer=null;
    }
    const playerSubmissionId=String(transferredPlayer?.submissionId||'').trim();
    const hasGameAccess=sessionStorage.getItem('varanasiGameAccess')==='1' && transferredPlayer && transferredPlayer.name;

    if(hasGameAccess){
      $('welcomeText').textContent='WELCOME, '+String(transferredPlayer.name).trim().toUpperCase();
    }
    
    const bgVideo=$('gameBackdropVideo');
    if(bgVideo){
      bgVideo.muted=true;
      bgVideo.play().catch(()=>{});
    }

    scrollTo(0,0);

    const GAME_STATUS_URL='https://preorder.varanasimovie.com/api/game/status';

    const normalizeGameMobile=()=>{
      const raw=String(
        transferredPlayer?.mobileE164 ||
        transferredPlayer?.mobile ||
        ''
      ).trim();

      if(!raw)return '';

      const digits=raw.replace(/\D/g,'');

      if(/^[6-9]\d{9}$/.test(digits)){
        return '+91'+digits;
      }

      if(/^91[6-9]\d{9}$/.test(digits)){
        return '+'+digits;
      }

      if(/^[1-9]\d{7,14}$/.test(digits)){
        return '+'+digits;
      }

      return '';
    };

    const isValidGameMobile=(mobile)=>/^\+[1-9]\d{7,14}$/.test(String(mobile||''));

    const statusSaysPlayed=(status)=>(
      status?.hasSpun===true ||
      status?.hasPlayed===true ||
      status?.played===true
    );

    const isAlreadyPlayedError=(value)=>{
      const message=String(
        value?.error ||
        value?.message ||
        value ||
        ''
      ).toLowerCase();

      return (
        message.includes('already completed your spin') ||
        message.includes('already completed the spin') ||
        message.includes('already spun') ||
        message.includes('already played') ||
        (message.includes('spin') && message.includes('already'))
      );
    };

    let gamePlayCompleted=false;
    const playerMobile=normalizeGameMobile();
    const playedStorageKey=playerMobile
      ? 'varanasiGamePlayed:'+playerMobile
      : '';

    const hideSpinControl=()=>{
      const dock=document.querySelector('.spinDock');
      const instruction=$('spinInstruction');
      const button=$('spinButton');

      if(dock){
        dock.hidden=true;
        dock.setAttribute('aria-hidden','true');
      }

      if(instruction){
        instruction.hidden=true;
        instruction.setAttribute('aria-hidden','true');
      }

      if(button){
        button.disabled=true;
        button.setAttribute('aria-disabled','true');
      }


      $('gamePage')?.classList.remove('isSpinning');
      document.querySelector('.realGlobe')?.classList.remove('realGlobe--spinning');

      if($('statusText')){
        $('statusText').textContent='SPIN COMPLETED';
      }
    };

    const markSpinCompleted=(status=null,{hideNow=true}={})=>{
      gamePlayCompleted=true;

      if(playedStorageKey){
        try{
          sessionStorage.setItem(
            playedStorageKey,
            JSON.stringify({
              played:true,
              mobile:playerMobile,
              isWinner:status?.isWinner===true,
              perkCode:status?.perkCode||null,
              savedAt:Date.now()
            })
          );
        }catch(e){}
      }

      if(status?.perkCode){
        window.lastPerkCode=status.perkCode;
      }

      if(hideNow){
        hideSpinControl();
      }
    };

    const getGameStatus=async()=>{
      if(!isValidGameMobile(playerMobile)){
        throw new Error('A verified mobile number is required to play.');
      }

      const response=await fetch(
        GAME_STATUS_URL+'?mobile='+encodeURIComponent(playerMobile),
        {
          method:'GET',
          headers:{'Accept':'application/json'},
          cache:'no-store'
        }
      );

      const data=await response.json().catch(()=>null);

      if(!response.ok){
        throw new Error(
          data?.error ||
          data?.message ||
          'Unable to verify game status.'
        );
      }

      return data||{};
    };

    const validateSpinEligibility=async()=>{
      if(!isValidGameMobile(playerMobile)){
        gamePlayCompleted=true;
        hideSpinControl();
        if($('statusText')){
          $('statusText').textContent='VERIFICATION REQUIRED';
        }
        return false;
      }

      if(playedStorageKey){
        try{
          const localPlayed=JSON.parse(sessionStorage.getItem(playedStorageKey)||'null');
          if(localPlayed?.played===true){
            gamePlayCompleted=true;
            hideSpinControl();
          }
        }catch(e){}
      }

      try{
        const status=await getGameStatus();

        if(statusSaysPlayed(status)){
          markSpinCompleted(status);
          return false;
        }

        if(gamePlayCompleted){
          hideSpinControl();
          return false;
        }

        return true;
      }catch(error){
        if(gamePlayCompleted){
          hideSpinControl();
          return false;
        }

        return true;
      }
    };

    let indexes=[0,1,2],spinning=false,win=false,count=0,muted=false,timers=[],intervals=[];
    function renderReels(){
      const reelsRoot=$('reels');
      const winnerAligned=!spinning&&win;

      reelsRoot.classList.toggle('winner-aligned',winnerAligned);
      document.querySelector('.reelFrame')?.classList.toggle('winner-aligned',winnerAligned);

      const reelNodes=indexes.map((idx,reelIndex)=>{
        const reel=document.createElement('div');
        reel.className='reel'+(spinning?' rolling':'');

        [-1,0,1].forEach((offset)=>{
          const relic=relics[(idx+offset+relics.length)%relics.length];

          const cell=document.createElement('div');
          cell.className='relicCell active';

          const imageWrap=document.createElement('div');
          imageWrap.className='relicImage';
          imageWrap.style.setProperty('--relic-accent',relic.accent);

          const img=document.createElement('img');
          img.src=safeResourceUrl(relic.image);
          img.alt=relic.name;
          img.style.objectPosition=relic.position;

          const shade=document.createElement('div');
          shade.className='relicShade';
          imageWrap.append(img,shade);

          const nameWrap=document.createElement('div');
          nameWrap.className='relicName relicName--clean';
          const strong=document.createElement('strong');
          strong.textContent=relic.name;
          nameWrap.appendChild(strong);

          cell.append(imageWrap,nameWrap);
          reel.appendChild(cell);
        });

        const number=document.createElement('span');
        number.className='reelNumber';
        number.textContent='0'+String(reelIndex+1);
        reel.appendChild(number);
        return reel;
      });

      reelsRoot.replaceChildren(...reelNodes);
    }
    function tone(type){if(muted)return;try{const C=window.AudioContext||window.webkitAudioContext;if(!C)return;const c=new C(),o=c.createOscillator(),g=c.createGain(),n=c.currentTime,b=type==='start'?64:type==='stop'?190:390;o.connect(g);g.connect(c.destination);o.type=type==='start'?'sawtooth':'sine';o.frequency.setValueAtTime(b,n);o.frequency.exponentialRampToValueAtTime(type==='start'?38:b*1.5,n+(type==='start'?.58:.18));g.gain.setValueAtTime(.0001,n);g.gain.exponentialRampToValueAtTime(type==='start'?.035:.07,n+.025);g.gain.exponentialRampToValueAtTime(.0001,n+(type==='start'?.62:.24));o.start(n);o.stop(n+(type==='start'?.64:.25));o.onended=()=>c.close()}catch(e){}}
    async function spin(){
      if(
        gamePlayCompleted ||
        spinning ||
        !$('winnerOverlay').hidden ||
        !$('resultOverlay').hidden ||
        !$('lossOverlay').hidden
      ){
        return;
      }

      if(!isValidGameMobile(playerMobile)){
        gamePlayCompleted=true;
        hideSpinControl();
        $('statusText').textContent='VERIFICATION REQUIRED';
        return;
      }

      try{
        const status=await getGameStatus();
        if(statusSaysPlayed(status)){
          markSpinCompleted(status);
          return;
        }
      }catch(error){
      }

      spinning=true;
      count++;
      tone('start');

      $('gamePage').classList.add('isSpinning');
      $('statusText').textContent='THREE REELS ALIGNING';
      $('pinText').textContent='IN MOTION';
      document.querySelector('.realGlobe')?.classList.add('realGlobe--spinning');
      $('spinInstruction').textContent='GLOBE IN MOTION · ALIGNMENT LOCKS IN 4–6 SECONDS';
      $('spinButton').disabled=true;
      $('spinCount').textContent='SPIN #'+String(count).padStart(2,'0');

      renderReels();

      [58,68,78].forEach((speed,reel)=>{
        const int=setInterval(()=>{
          indexes[reel]=(indexes[reel]+1)%6;
          renderReels();
        },speed);
        intervals.push(int);
      });

      const abortSpin=(message)=>{
        intervals.forEach(clearInterval);
        timers.forEach(clearTimeout);
        intervals=[];
        timers=[];
        spinning=false;

        $('gamePage').classList.remove('isSpinning');
        document.querySelector('.realGlobe')?.classList.remove('realGlobe--spinning');

        if(gamePlayCompleted){
          hideSpinControl();
        }else{
          $('statusText').textContent='READY';
          $('pinText').textContent='TAP TO START';
          $('spinInstruction').textContent=message||'UNABLE TO COMPLETE SPIN · TAP TO TRY AGAIN';
          $('spinButton').disabled=false;
        }

        renderReels();
      };

      let data=null;
      let targets=[];

      try{
        const response=await fetch(
          'https://preorder.varanasimovie.com/api/game/spin',
          {
            method:'POST',
            headers:{
              'Accept':'application/json',
              'Content-Type':'application/json'
            },
            body:JSON.stringify({
              mobile:playerMobile,
              submissionId:playerSubmissionId
            })
          }
        );

        data=await response.json().catch(()=>null);

        if(!response.ok || data?.ok===false){
          if(isAlreadyPlayedError(data)){
            markSpinCompleted(data||{});
            abortSpin();
            return;
          }

          throw new Error(
            data?.error ||
            data?.message ||
            'Unable to complete your spin right now.'
          );
        }

        markSpinCompleted(data,{hideNow:false});

        const backendWinner=data?.isWinner===true;

        let symbols=data?.reelSymbols;

        if(typeof symbols==='string'){
          symbols=symbols.split(',').map(value=>value.trim()).filter(Boolean);
        }

        if(backendWinner){
          targets=Array(3).fill(RUDHRA_INDEX);
        }else if(Array.isArray(symbols) && symbols.length===3){
          targets=symbols.map((symbol)=>{
            const normalized=String(symbol||'').trim().toUpperCase();
            const index=relics.findIndex(
              relic=>relic.apiName===normalized || relic.name===normalized
            );
            return index===-1 ? 0 : index;
          });
        }else{
          targets=Array.from({length:3},()=>Math.floor(Math.random()*relics.length));
        }

        if(!backendWinner && targets.length===3 && targets.every(value=>value===targets[0])){
          targets[2]=(targets[2]+1)%relics.length;
        }

        win=
          backendWinner &&
          RUDHRA_INDEX>=0 &&
          targets.length===3 &&
          targets.every(value=>value===RUDHRA_INDEX);

        if(data?.perkCode){
          window.lastPerkCode=data.perkCode;
        }
      }catch(error){
        abortSpin(
          error instanceof Error
            ? error.message
            : 'Unable to complete your spin right now.'
        );
        return;
      }

      [4700,5400,6100].forEach((delay,reel)=>{
        timers.push(setTimeout(()=>{
          clearInterval(intervals[reel]);
          indexes[reel]=targets[reel];
          renderReels();
          tone('stop');

          if(reel===2){
            timers.push(setTimeout(()=>{
              spinning=false;
              intervals=[];
              timers=[];

              renderReels();
              $('gamePage').classList.remove('isSpinning');
              document.querySelector('.realGlobe')?.classList.remove('realGlobe--spinning');

              hideSpinControl();

              if(win){
                $('winnerOverlay').hidden=false;
                tone('reveal');
              }else{
                $('lossOverlay').hidden=false;
              }
            },3000));
          }
        },delay));
      });
    }

    function openResult(){
      const code=String(
        window.lastPerkCode ||
        ('VAR-RUDRA-'+Math.random().toString(36).slice(2,7).toUpperCase())
      );

      $('resultOverlay').hidden=false;
      $('resultTitle').textContent='VARANASI';

      const miniRelics=indexes.map((idx)=>{
        const relic=relics[idx];
        const item=document.createElement('div');
        item.className='miniRelic miniRelic--winner';

        const glow=document.createElement('div');
        glow.className='miniRelicGlow';
        glow.setAttribute('aria-hidden','true');

        const img=document.createElement('img');
        img.src=safeResourceUrl(relic.image);
        img.alt=relic.name;
        img.style.objectPosition=relic.position;

        const label=document.createElement('strong');
        label.textContent=relic.name;

        item.append(glow,img,label);
        return item;
      });
      $('miniRelics').replaceChildren(...miniRelics);

      const wish=document.createElement('div');
      wish.className='scratchWish';

      const kicker=document.createElement('span');
      kicker.className='scratchWishKicker';
      kicker.textContent='CONGRATULATIONS';

      const title=document.createElement('strong');
      title.textContent='YOUR VARANASI MOMENT IS UNLOCKED.';

      const message=document.createElement('p');
      message.textContent='May this win bring you closer to something unforgettable from the world of Varanasi.';

      const perk=document.createElement('small');
      perk.className='scratchPerkCode';
      perk.textContent='PERK CODE · '+code;

      const join=document.createElement('button');
      join.className='scratchJoinWaitlist';
      join.id='scratchJoinWaitlist';
      join.type='button';
      join.textContent='JOIN WAITLIST';

      const status=document.createElement('p');
      status.className='scratchJoinStatus';
      status.id='scratchJoinStatus';
      status.setAttribute('aria-live','polite');

      wish.append(kicker,title,message,perk,join,status);
      $('scratchResult').replaceChildren(wish);

      prepareScratch();
    }

    function prepareScratch(){
      const canvas=$('scratchCanvas');
      const stage=$('scratchStage');
      const rect=stage.getBoundingClientRect();
      const ratio=Math.min(devicePixelRatio||1,2);
      const ctx=canvas.getContext('2d');

      stage.classList.remove('isRevealed');
      $('scratchSheen').hidden=false;

      const scratchJoinButton=$('scratchJoinWaitlist');
      if(scratchJoinButton){
        scratchJoinButton.disabled=true;
        scratchJoinButton.setAttribute('aria-disabled','true');
      }

      canvas.width=Math.floor(rect.width*ratio);
      canvas.height=Math.floor(rect.height*ratio);
      ctx.setTransform(ratio,0,0,ratio,0,0);

      const foil=ctx.createLinearGradient(0,0,rect.width,rect.height);
      [
        ['0','#21130c'],
        ['.14','#9f692f'],
        ['.33','#f0c779'],
        ['.49','#fff1bd'],
        ['.65','#b67b36'],
        ['.84','#e4b964'],
        ['1','#261710']
      ].forEach(([s,c])=>foil.addColorStop(+s,c));

      ctx.fillStyle=foil;
      ctx.fillRect(0,0,rect.width,rect.height);

      ctx.globalAlpha=.24;
      for(let i=0;i<420;i++){
        ctx.fillStyle=i%4===0?'#fff9dc':i%3===0?'#4b2f19':'#d9b06a';
        const z=Math.random()*1.8+.35;
        ctx.fillRect(Math.random()*rect.width,Math.random()*rect.height,z,z);
      }
      ctx.globalAlpha=1;

      ctx.strokeStyle='rgba(255,241,193,.58)';
      ctx.strokeRect(12,12,rect.width-24,rect.height-24);

      ctx.fillStyle='#2a190e';
      ctx.textAlign='center';
      ctx.font='700 12px Arial';
      ctx.fillText('SCRATCH TO REVEAL',rect.width/2,rect.height/2-3);
      ctx.font='500 8px Arial';
      ctx.fillText('YOUR VARANASI MOMENT',rect.width/2,rect.height/2+17);

      let down=false,last=null,distance=0,revealed=false;

      const completeScratch=()=>{
        if(revealed)return;
        revealed=true;
        down=false;
        stage.classList.add('isRevealed');
        $('scratchSheen').hidden=true;

        const button=$('scratchJoinWaitlist');
        if(button){
          button.disabled=false;
          button.removeAttribute('aria-disabled');
        }
      };

      const scratch=e=>{
        if(!down||revealed)return;

        const r=canvas.getBoundingClientRect();
        const x=e.clientX-r.left;
        const y=e.clientY-r.top;
        const prev=last||{x,y};
        const seg=Math.hypot(x-prev.x,y-prev.y);
        const radius=Math.max(22,r.width*.045);
        const steps=Math.max(1,Math.ceil(seg/(radius*.32)));

        ctx.save();
        ctx.setTransform(ratio,0,0,ratio,0,0);
        ctx.globalCompositeOperation='destination-out';

        for(let i=0;i<=steps;i++){
          const t=i/steps;
          const px=prev.x+(x-prev.x)*t;
          const py=prev.y+(y-prev.y)*t;
          const g=ctx.createRadialGradient(px,py,0,px,py,radius);
          g.addColorStop(0,'rgba(0,0,0,1)');
          g.addColorStop(.72,'rgba(0,0,0,.92)');
          g.addColorStop(1,'rgba(0,0,0,0)');
          ctx.fillStyle=g;
          ctx.beginPath();
          ctx.arc(px,py,radius,0,Math.PI*2);
          ctx.fill();
        }

        ctx.restore();

        distance+=seg;
        last={x,y};

        if(distance>r.width*1.05){
          completeScratch();
        }
      };

      canvas.addEventListener('pointerdown',(event)=>{
        down=true;
        last=null;
        canvas.setPointerCapture(event.pointerId);
        scratch(event);
      });
      canvas.addEventListener('pointermove',scratch);
      canvas.addEventListener('pointerup',()=>{down=false;last=null});
      canvas.addEventListener('pointercancel',()=>{down=false;last=null});
    }

    $('spinButton').addEventListener('click',spin);
    $('perkCoinTap').addEventListener('click',()=>{$('winnerOverlay').hidden=true;openResult()});
    const closeResult=()=>{$('resultOverlay').hidden=true;hideSpinControl()};
    $('closeResult').addEventListener('click',closeResult);
    $('closeLoss').addEventListener('click',openMerchPopup);
    renderReels();
    validateSpinEligibility();
  

    const merchOverlay=$('merchWaitlistOverlay');
    const merchClose=$('merchCloseModal');
    const merchJoin=$('merchJoinWaitlist');
    const merchSuccess=$('merchSuccess');
    const merchConfetti=$('merchConfetti');
    const merchReturn=$('merchReturnButton');
    const merchMicro=document.querySelector('.merchMicro');
    const merchJoinDefaultNodes=Array.from(merchJoin.childNodes,(node)=>node.cloneNode(true));
    const merchMicroDefault=merchMicro?.textContent || '';
    const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function openMerchPopup(){
      $('lossOverlay').hidden=true;
      $('resultOverlay').hidden=true;
      merchSuccess.classList.remove('active');
      merchSuccess.setAttribute('aria-hidden','true');
      merchConfetti.replaceChildren();

      merchJoin.disabled=false;
      merchJoin.replaceChildren(...merchJoinDefaultNodes.map((node)=>node.cloneNode(true)));
      if(merchMicro){
        merchMicro.textContent=merchMicroDefault;
        merchMicro.style.color='';
      }

      merchOverlay.hidden=false;
      requestAnimationFrame(()=>merchClose.focus({preventScroll:true}));
    }

    const closeMerchPopup=()=>{
      merchOverlay.hidden=true;
      merchSuccess.classList.remove('active');
      merchSuccess.setAttribute('aria-hidden','true');
      merchConfetti.replaceChildren();

      hideSpinControl();
    };

    const makeMerchConfetti=()=>{
      merchConfetti.replaceChildren();
      if(reduceMotion)return;
      const palette=[
        ['#ffe69b','#a86118'],
        ['#fff1b8','#c5872e'],
        ['#dda13c','#70400d'],
        ['#c17c27','#f4cd68']
      ];
      for(let i=0;i<120;i+=1){
        const piece=document.createElement('i');
        const colors=palette[Math.floor(Math.random()*palette.length)];
        piece.style.left=`${Math.random()*100}%`;
        piece.style.width=`${3+Math.random()*5}px`;
        piece.style.height=`${7+Math.random()*12}px`;
        piece.style.background=`linear-gradient(180deg,${colors[0]},${colors[1]})`;
        piece.style.setProperty('--dur',`${4.1+Math.random()*4.1}s`);
        piece.style.setProperty('--delay',`${Math.random()*1.9}s`);
        piece.style.setProperty('--drift',`${-90+Math.random()*180}px`);
        piece.style.setProperty('--spin',`${360+Math.random()*1080}deg`);
        merchConfetti.appendChild(piece);
      }
    };

    const showMerchSuccess=()=>{
      makeMerchConfetti();
      merchSuccess.classList.add('active');
      merchSuccess.setAttribute('aria-hidden','false');
      merchReturn.focus({preventScroll:true});
    };

    const getMerchMobile=()=>{
      const raw=String(
        transferredPlayer?.mobileE164 ||
        transferredPlayer?.mobile ||
        ''
      ).trim();

      if(!raw)return '';

      if(raw.startsWith('+'))return raw;

      const digits=raw.replace(/\D/g,'');

      if(/^[6-9]\d{9}$/.test(digits)){
        return '+91'+digits;
      }

      return digits ? '+'+digits : '';
    };

    const updateMerchandiseStatus=async({
      button,
      statusEl=null,
      loadingText='SAVING…'
    }={})=>{
      const mobile=getMerchMobile();

      if(!mobile){
        const message='Unable to identify your verified mobile number. Please return home and enter again.';
        if(statusEl){
          statusEl.textContent=message;
          statusEl.classList.add('is-error');
        }
        throw new Error(message);
      }

      const originalButtonNodes=button
        ? Array.from(button.childNodes,(node)=>node.cloneNode(true))
        : [];

      if(button){
        button.disabled=true;
        const label=document.createElement('span');
        label.className='label';
        label.textContent=loadingText;
        const arrow=document.createElement('span');
        arrow.className='arrow';
        arrow.setAttribute('aria-hidden','true');
        arrow.textContent='…';
        button.replaceChildren(label,arrow);
      }

      if(statusEl){
        statusEl.textContent='Saving your merchandise reminder…';
        statusEl.classList.remove('is-error');
      }

      try{
        const response=await fetch(
          'https://preorder.varanasimovie.com/api/updatemerchandise',
          {
            method:'POST',
            headers:{
              'Accept':'application/json',
              'Content-Type':'application/x-www-form-urlencoded'
            },
            body:new URLSearchParams({
              mobile,
              isMerchandise:1,
              submissionId:playerSubmissionId
            }).toString()
          }
        );

        const data=await response.json().catch(()=>null);

        if(!response.ok || !data?.ok){
          throw new Error(
            data?.error ||
            data?.message ||
            'Unable to join the merchandise waitlist right now.'
          );
        }

        window.lastMerchandiseUpdate=data;
        return data;
      }catch(error){
        if(button){
          button.disabled=false;
          button.replaceChildren(...originalButtonNodes.map((node)=>node.cloneNode(true)));
        }

        if(statusEl){
          statusEl.textContent=
            error instanceof Error
              ? error.message
              : 'Unable to join the merchandise waitlist right now.';
          statusEl.classList.add('is-error');
        }

        throw error;
      }
    };

    const openFinalMerchSuccess=()=>{
      $('resultOverlay').hidden=true;
      merchOverlay.hidden=false;
      merchSuccess.classList.remove('active');
      merchSuccess.setAttribute('aria-hidden','true');
      merchConfetti.replaceChildren();

      requestAnimationFrame(()=>{
        showMerchSuccess();
      });
    };

    const joinMerchWaitlist=async()=>{
      try{
        await updateMerchandiseStatus({
          button:merchJoin,
          statusEl:merchMicro,
          loadingText:'SETTING REMINDER'
        });

        showMerchSuccess();
      }catch(error){
      }
    };

    $('scratchResult').addEventListener('click',(event)=>{
      const button=event.target.closest('#scratchJoinWaitlist');
      if(!button || button.disabled)return;

      openMerchPopup();
    });
    merchClose.addEventListener('click',closeMerchPopup);
    merchJoin.addEventListener('click',joinMerchWaitlist);
    merchReturn.addEventListener('click',()=>{hideSpinControl();window.location.href='/';});

    merchOverlay.addEventListener('click',(event)=>{
      if(event.target===merchOverlay)closeMerchPopup();
    });

    document.addEventListener('keydown',(event)=>{
      if(event.key==='Escape'&&!merchOverlay.hidden){
        closeMerchPopup();
      }
    });


      const trishulCursor = document.getElementById('trishulCustomCursor');

      if (trishulCursor && window.matchMedia('(pointer:fine)').matches) {
        let cursorX = -100;
        let cursorY = -100;
        let cursorRAF = 0;

        const renderTrishulCursor = () => {
          trishulCursor.style.left = cursorX + 'px';
          trishulCursor.style.top = cursorY + 'px';
          cursorRAF = 0;
        };

        window.addEventListener('pointermove', (event) => {
          if (event.pointerType === 'touch') return;

          cursorX = event.clientX;
          cursorY = event.clientY;
          trishulCursor.classList.add('is-visible');

          if (event.target.closest('button, a, input, select, textarea, [role="button"]')) {
            trishulCursor.classList.add('is-hover');
          } else {
            trishulCursor.classList.remove('is-hover');
          }

          if (!cursorRAF) {
            cursorRAF = requestAnimationFrame(renderTrishulCursor);
          }
        }, { passive:true });

        document.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'touch') {
            trishulCursor.classList.add('is-active');
          }
        }, { passive:true });

        document.addEventListener('pointerup', () => {
          trishulCursor.classList.remove('is-active');
        }, { passive:true });

        document.addEventListener('mouseleave', () => {
          trishulCursor.classList.remove('is-visible');
        });

        window.addEventListener('blur', () => {
          trishulCursor.classList.remove('is-visible');
        });
      }

    })();
